import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  selectCompanies,
  selectCompaniesLoading,
  selectDownloadingType,
  selectError,
  selectHasMore,
  selectLoading,
  selectRegenerating,
  selectSurveys,
} from './selectors/invoice.selectors';

@Injectable({ providedIn: 'root' })
export class InvoiceSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly surveys = this._store.selectSignal(selectSurveys);
  public readonly loading = this._store.selectSignal(selectLoading);
  public readonly error = this._store.selectSignal(selectError);
  public readonly companies = this._store.selectSignal(selectCompanies);
  public readonly companiesLoading = this._store.selectSignal(
    selectCompaniesLoading,
  );
  public readonly downloadingType = this._store.selectSignal(
    selectDownloadingType,
  );
  public readonly regenerating = this._store.selectSignal(selectRegenerating);
  public readonly hasMore = this._store.selectSignal(selectHasMore);
}
